import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  declare readonly inputTargets: HTMLInputElement[];
  private boundHandleInput!: (event: Event) => void;

  connect() {
    this.boundHandleInput = this.handleInput.bind(this);

    this.inputTargets.forEach((input) => {
      input.addEventListener("input", this.boundHandleInput);
    });
  }

  disconnect() {
    this.inputTargets.forEach((input) => {
      input.removeEventListener("input", this.boundHandleInput);
    });
  }

  handleInput(event: Event) {
    const source = event.target as HTMLInputElement;
    const value = source.value;
    const syncKey = source.dataset.syncKey;

    this.inputTargets.forEach((input) => {
      if (
        input !== source &&
        input.value !== value &&
        input.dataset.syncKey === syncKey
      ) {
        input.value = value;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }
}
